<template>
  <v-app>
    <v-container class="background">
      <div>
        <v-btn
          dark
          block
          class="pa-2 text-h6 font-weight-bold"
          color="#3D3D3D"
          @click="select_dialog = true"
        >
          {{ selectedInstitution }}
        </v-btn>

        <div class="pa-2 my-4">
          <template v-if="selectedType === 'check-in-out'">
            <v-row dense>
              <v-col cols="6" class="text-center text-h6 font-weight-bold"
                ><v-card shaped color="#CDC1FF"
                  >全部<br />
                  {{ stats.total }}</v-card
                ></v-col
              >
              <v-col cols="6" class="text-center text-h6 font-weight-bold"
                ><v-card shaped color="#FFCCEA">未簽到退 <br />{{ stats.pending }}</v-card></v-col
              >
              <v-col cols="6" class="text-center text-h6 font-weight-bold"
                ><v-card shaped color="#FFF6E3"
                  >已簽到<br />
                  {{ stats.checkIn }}</v-card
                ></v-col
              >
              <v-col cols="6" class="text-center text-h6 font-weight-bold"
                ><v-card shaped color="#BFECFF"
                  >已簽退<br />
                  {{ stats.checkOut }}</v-card
                ></v-col
              >
            </v-row>
          </template>
          <template v-else-if="selectedType === 'vitalsign' || selectedType === 'daily-record'">
            <v-row dense>
              <v-col cols="4" class="text-center text-h6 font-weight-bold"
                ><v-card shaped color="#CDC1FF">全部 <br />{{ stats.total }}</v-card></v-col
              >
              <v-col cols="4" class="text-center text-h6 font-weight-bold"
                ><v-card shaped color="#FFCCEA">未完成 <br />{{ stats.notComplete }}</v-card></v-col
              >
              <v-col cols="4" class="text-center text-h6 font-weight-bold"
                ><v-card shaped color="#BFECFF"
                  >已完成<br />
                  {{ stats.complete }}</v-card
                ></v-col
              >
            </v-row>
          </template>
        </div>

        <!-- 全螢幕的選單對話框 -->
        <v-dialog
          v-model="select_dialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="#025464">
              <v-btn icon @click="select_dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>選擇機構</v-toolbar-title>
            </v-toolbar>
            <v-list>
              <v-list-item
                v-for="(item, index) in institutionList"
                :key="index"
                @click="selectInstitution(item)"
              >
                <v-list-item-title class="pa-2 text-h6 font-weight-bold text-center">{{
                  item
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-dialog>
      </div>
      <template v-if="selectedType === 'check-in-out'">
        <!-- 未簽到退 -->
        <div class="text-center text-h4 font-weight-bold pa-2 my-4" style="color: #990000">
          {{ pendingTitle }}
        </div>
        <v-row v-if="pendingCases.length" class="pa-2">
          <v-col v-for="(c, index) in pendingCases" :key="index" cols="4">
            <v-btn
              large
              class="font-weight-bold text-h6 btn"
              :style="{ color: getTextColor(c.case_num, (type = 'check-in-out')) }"
              :color="getButtonColor(c.case_num, (color = '#FFCCEA'))"
              @click="triggerSelection(c.name, c.case_num)"
            >
              {{ c.name }}
            </v-btn>
          </v-col>
        </v-row>
        <div v-else class="text-center text-h5 font-weight-bold pa-2">無個案</div>

        <!-- 已簽到 -->
        <div class="text-center text-h4 font-weight-bold pa-2 my-4" style="color: #009900">
          {{ checkInTitle }}
        </div>
        <v-row v-if="checkInCases.length" class="pa-2">
          <v-col v-for="(c, index) in checkInCases" :key="index" cols="4">
            <v-btn
              large
              class="font-weight-bold text-h6 btn"
              :style="{ color: getTextColor(c.case_num, (type = 'check-in-out')) }"
              :color="getButtonColor(c.case_num, (color = '#FFF6E3'))"
              @click="triggerSelection(c.name, c.case_num)"
            >
              {{ c.name }}
            </v-btn>
          </v-col>
        </v-row>
        <div v-else class="text-center text-h5 font-weight-bold pa-2">無個案</div>

        <!-- 已簽退 -->
        <div class="text-center text-h4 font-weight-bold pa-2 my-4" style="color: #000099">
          {{ checkOutTitle }}
        </div>
        <v-row v-if="checkOutCases.length" class="pa-2">
          <v-col v-for="(c, index) in checkOutCases" :key="index" cols="4">
            <v-btn
              large
              class="font-weight-bold text-h6 btn"
              :style="{ color: getTextColor(c.case_num, (type = 'check-in-out')) }"
              :color="getButtonColor(c.case_num, (color = '#BFECFF'))"
              @click="triggerSelection(c.name, c.case_num)"
            >
              {{ c.name }}
            </v-btn>
          </v-col>
        </v-row>
        <div v-else class="text-center text-h5 font-weight-bold pa-2">無個案</div>
      </template>

      <template v-else>
        <div class="text-center text-h4 font-weight-bold pa-2 my-4" style="color: #990000">
          {{ pendingTitle }}
        </div>
        <v-row v-if="pendingCases.length" class="pa-2">
          <v-col v-for="(c, index) in pendingCases" :key="index" cols="4">
            <v-btn
              large
              class="font-weight-bold text-h6 btn"
              :style="{ color: getTextColor(c.case_num, (type = 'others')) }"
              :color="getButtonColor(c.case_num, (color = '#FFCCEA'))"
              @click="triggerSelection(c.name, c.case_num)"
            >
              {{ c.name }}
            </v-btn>
          </v-col>
        </v-row>
        <div v-else class="text-center text-h5 font-weight-bold pa-2">無個案</div>
        <div class="text-center text-h4 font-weight-bold pa-2 my-4" style="color: #009900">
          {{ completedTitle }}
        </div>
        <v-row v-if="completedCases.length" class="pa-2">
          <v-col v-for="(c, index) in completedCases" :key="index" cols="4">
            <v-btn
              large
              class="font-weight-bold text-h6 btn"
              :color="getButtonColor(c.case_num, (color = '#BFECFF'))"
              :style="{ color: getTextColor(c.case_num, (type = 'others')) }"
              @click="triggerSelection(c.name, c.case_num)"
            >
              {{ c.name }}
            </v-btn>
          </v-col>
        </v-row>
        <div v-else class="text-center text-h5 font-weight-bold pa-2">無個案</div>
      </template>

      <SignDialog
        v-model="sign_dialog"
        :bulkedId="selectedCasesId"
        :bulkedName="selectedCasesName"
        :attendanceList="apiData"
        :staffId="staff_id"
        :date="date"
        :time="time"
        :status="sign_status"
        :isViewOnly="true"
        @get_list="getList"
        @close_dialog="closeDialog"
      />

      <VitalSignDialog
        v-model="dialog"
        :caseName="case_name"
        :caseId="case_id"
        :staffId="staff_id"
        :exist="exist"
        :date="date"
        :time="time"
        :temperature="temperature"
        :hr="hr"
        :shrink="shrink"
        :relax="relax"
        :spo2="spo2"
        :bs="bs"
        :weight="weight"
        :breathe="breathe"
        @get_list="getList"
        @get_vitalSign="getVitalSign"
        @trigger_selection="triggerSelection"
      />

      <CaseRecordDialog
        v-model="add_record_dialog"
        :caseName="case_name"
        :caseId="case_id"
        :date="date"
        :staffId="staff_id"
        :completed="completed"
        @get_list="getList"
      />
    </v-container>

    <!-- 只有「簽到簽退」時，才會顯示這個確認按鈕 -->
    <v-btn
      v-if="isMultiSelect && selectedCasesId.length && !sign_dialog"
      large
      fab
      dark
      color="#4d2673"
      class="floating-btn"
      @click="openDialog"
    >
      <v-icon>mdi-check</v-icon>
    </v-btn>
  </v-app>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import VitalSignDialog from '@/components/VitalSignDialog.vue'
import SignDialog from '@/components/SignDialog.vue'
import CaseRecordDialog from '@/components/CaseRecordDialog.vue'

export default {
  components: {
    SignDialog,
    VitalSignDialog,
    CaseRecordDialog,
  },
  data() {
    return {
      selectedCasesId: [],
      selectedCasesName: [],
      selectedBlock: null,
      selectedType: this.$route.params.type,
      sign_dialog: false,
      add_record_dialog: false,
      dialog: false,
      exist: false,
      completed: false,
      cases: [],
      staff_id: '',
      case_id: '',
      case_name: '',
      date: moment().format('YYYY-MM-DD'),
      time: moment().format('HH:mm'),
      temperature: '',
      hr: '',
      shrink: '',
      relax: '',
      bs: '',
      spo2: '',
      weight: '',
      breathe: '',
      apiData: [],
      vitalsignData: [],
      sign_status: '',
      // 篩選機構
      select_dialog: false,
      institutionList: [],
      selectedInstitution: null,
      filteredRecords: [],
    }
  },
  computed: {
    isMultiSelect() {
      return this.selectedType === 'check-in-out' // 簽到簽退支援多選
    },
    stats() {
      const filtered = this.filteredRecords
      if (this.selectedType === 'check-in-out') {
        const total = filtered.length
        const pending = filtered.filter((record) => record.has_written === false).length
        const checkIn = filtered.filter(
          (record) => record.has_written === true && !record.completed
        ).length
        const checkOut = filtered.filter(
          (record) => record.has_written === true && record.completed
        ).length
        return { total, pending, checkIn, checkOut }
      } else if (this.selectedType === 'vitalsign' || this.selectedType === 'daily-record') {
        const total = filtered.length
        const notComplete = filtered.filter((record) => record.has_written === false).length
        const complete = filtered.filter((record) => record.has_written === true).length
        return { total, notComplete, complete }
      } else {
        return { total: filtered.length }
      }
    },
    pendingCases() {
      return this.filteredRecords.filter((record) => record.has_written === false)
    },
    completedCases() {
      return this.filteredRecords.filter((record) => record.has_written === true)
    },
    checkInCases() {
      if (this.selectedType === 'check-in-out') {
        let data = this.filteredRecords.filter((record) => record.has_written === true)
        return data.filter((d) => d.completed === false)
      }
      return []
    },
    checkOutCases() {
      if (this.selectedType === 'check-in-out') {
        let data = this.filteredRecords.filter((record) => record.has_written === true)
        return data.filter((d) => d.completed === true)
      }
      return []
    },
    pendingTitle() {
      switch (this.selectedType) {
        case 'check-in-out':
          return '未完成簽到退'
        case 'vitalsign':
          return '未量測生理數據'
        case 'daily-record':
          return '未填寫日誌'
        default:
          return '未完成個案'
      }
    },
    completedTitle() {
      switch (this.selectedType) {
        case 'vitalsign':
          return '已量測生理數據'
        case 'daily-record':
          return '已填寫日誌'
        default:
          return '已完成個案'
      }
    },
    checkInTitle() {
      if (this.selectedType === 'check-in-out') {
        return '已簽到完成'
      }
      return ''
    },
    checkOutTitle() {
      if (this.selectedType === 'check-in-out') {
        return '已簽退完成'
      }
      return ''
    },
  },
  methods: {
    async getList() {
      let url = ''
      if (this.selectedType === 'check-in-out') {
        url = `/api/attendance/check_today_attendance`
      } else if (this.selectedType === 'vitalsign') {
        url = `/api/attendance/check_today_vitalsign`
      } else if (this.selectedType === 'daily-record') {
        url = `/api/journal/get_all_record?date=${this.date}`
      }
      let config = {
        method: 'get',
        url: url,
        header: {},
      }
      try {
        let res = await axios.request(config)
        console.log(res.data.data)
        this.apiData = res.data.data
        this.cases = this.apiData.map((c) => ({
          id: c.case_num,
          name: c.name,
        }))
        this.filteredRecords = this.apiData
        this.institutionList = [...new Set(res.data.data.map((item) => item.institution))]
        this.institutionList.unshift('所有機構')
        if (!this.selectedInstitution && this.institutionList.length) {
          this.selectedInstitution = this.institutionList[0]
        }
      } catch (error) {
        console.log(error)
      }
      this.filteredRecords = this.filterByInstitution(this.apiData)
    },
    selectInstitution(item) {
      this.selectedInstitution = item
      this.select_dialog = false
      this.filteredRecords = this.filterByInstitution(this.apiData)
    },
    filterByInstitution(data) {
      if (this.selectedInstitution === '所有機構') {
        return data
      } else if (this.selectedInstitution) {
        return data.filter((item) => item.institution === this.selectedInstitution)
      } else {
        return data
      }
    },
    async getVitalSign() {
      let config = {
        method: 'get',
        url: `/api/attendance/list_vital_sign?date=${this.date}`,
        header: {},
      }
      try {
        let res = await axios.request(config)
        this.vitalsignData = res.data.data
      } catch (error) {
        console.log(error)
      }
    },
    getButtonColor(caseId, color) {
      return this.selectedCasesId.includes(caseId) ? '#ff873b' : color
    },
    getTextColor(caseId, type) {
      return this.selectedCasesId.includes(caseId) ? 'white' : 'black'
    },
    triggerSelection(caseName, caseId) {
      this.case_id = caseId
      this.case_name = caseName
      this.date = moment().format('YYYY-MM-DD')
      this.time = moment().format('HH:mm')
      if (this.selectedType === 'check-in-out') {
        // 簽到簽退：根據has_written與completed來分辨區塊
        const currentRecord = this.filteredRecords.find((record) => record.case_num === caseId)
        if (!currentRecord) return
        const newCaseBlock =
          currentRecord.has_written === false
            ? 'pending'
            : currentRecord.completed
            ? 'checkOut'
            : 'checkIn'
        // 只保留與目前新選個案相同區塊的個案
        let updatedCases = this.selectedCasesId.filter((id) => {
          const record = this.filteredRecords.find((r) => r.case_num === id)
          if (!record) return false
          const recordBlock =
            record.has_written === false ? 'pending' : record.completed ? 'checkOut' : 'checkIn'
          return recordBlock === newCaseBlock
        })
        // 切換目前個案的選取狀態
        if (updatedCases.includes(caseId)) {
          updatedCases = updatedCases.filter((id) => id !== caseId)
          // 若沒有選取個案，則重置所選區塊
          if (updatedCases.length === 0) {
            this.selectedBlock = null
          }
        } else {
          updatedCases.push(caseId)
          this.selectedBlock = newCaseBlock
        }
        this.selectedCasesId = updatedCases
        this.selectedCasesName = updatedCases.map((id) => {
          const record = this.filteredRecords.find((r) => r.case_num === id)
          return record ? record.name : ''
        })
      } else if (this.selectedType === 'vitalsign') {
        // 生理數據
        const case_record = this.filterByInstitution(this.vitalsignData).find(
          (item) => item.case_num === this.case_id
        )
        console.log(case_record)
        const datetime = case_record.record_datetime
        if (datetime !== undefined && datetime !== null && datetime !== '') {
          let localDateTime = moment.utc(datetime).local()
          this.date = localDateTime.format('YYYY-MM-DD')
          this.time = localDateTime.format('HH:mm')
        }
        this.temperature = case_record.temperature
        this.hr = case_record.hr
        this.shrink = case_record.shrink
        this.relax = case_record.relax
        this.spo2 = case_record.SPO2
        this.bs = case_record.blood_sugar
        this.weight = case_record.weight
        this.breathe = case_record.breathe
        this.exist = [
          this.temperature,
          this.hr,
          this.shrink,
          this.relax,
          this.spo2,
          this.bs,
          this.weight,
          this.breathe,
        ].some((val) => val !== undefined && val !== null && val !== '')
        this.dialog = true
      } else if (this.selectedType === 'daily-record') {
        const case_record = this.filterByInstitution(this.apiData).find(
          (item) => item.case_num === this.case_id
        )
        this.completed = case_record.has_written
        this.add_record_dialog = true
      }
    },
    openDialog() {
      if (this.selectedCasesId.length === 0) {
        alert('請選擇至少一位個案')
        return
      }
      switch (this.selectedBlock) {
        case 'pending':
          this.sign_status = '簽到'
          break
        case 'checkIn':
          this.sign_status = '簽退'
          break
        default:
          this.sign_status = '簽到'
      }
      this.sign_dialog = true
    },
    closeDialog() {
      this.selectedCasesId = []
      this.sign_dialog = false
    },
  },
  mounted() {
    this.getList()
    this.getVitalSign()
  },
  created() {
    let staff = localStorage.getItem('staff')
    this.staff_id = JSON.parse(staff).id
  },
}
</script>

<style>
.background {
  background-color: #e2e2e2;
}

.floating-btn {
  position: fixed;
  bottom: 100px;
  right: 20px;
  z-index: 1000;
}

.btn {
  width: 100%;
}
</style>
